import type React from "react";
import CleanupWarningBanner from "./CleanupWarningBanner";
import PadControls from "./PadControls";
import type { ParsedAssetDefinition } from "./UploadPage";
import UploadPreviewTable from "./UploadPreviewTable";
import type { PadConfig } from "./padSerialNumber";

const requiredHeaders = ["serial_number", "asset_type", "address"];

const optionalHeaders = [
  "asset_position_reference",
  "group",
  "location_reference",
  "configuration",
];

interface Props {
  definitions: ParsedAssetDefinition[];
  padConfig: PadConfig;
  setPadConfig: (config: PadConfig) => void;
}

export default function SimpleAssetRegisterUploadPreview(
  props: Props,
): React.ReactElement {
  const { definitions, padConfig, setPadConfig } = props;

  return (
    <>
      <PadControls padConfig={padConfig} setPadConfig={setPadConfig} />
      <CleanupWarningBanner definitions={definitions} />
      <UploadPreviewTable
        definitions={definitions}
        requiredHeaders={requiredHeaders}
        optionalHeaders={optionalHeaders}
        uploadedEntityName={"asset"}
        trafficLight={true}
      />
    </>
  );
}
